<base-wrapper
  logo="assets-global/images/stazzle-medical.svg"
  [applicationSections]="sections"
  [userMenu]="userMenu"
></base-wrapper>
